export const CLEAR_OFFER_MANAGEMENT_STATE = 'CLEAR_OFFER_MANAGEMENT_STATE';

export const GET_ALL_OFFERS = 'GET_ALL_OFFERS';
export const GET_ALL_OFFERS_SUCCESS = 'GET_ALL_OFFERS_SUCCESS';
export const GET_ALL_OFFERS_ERROR = 'GET_ALL_OFFERS_ERROR';

export const GET_OFFER_BY_ID = 'GET_OFFER_BY_ID';
export const GET_OFFER_BY_ID_SUCCESS = 'GET_OFFER_BY_ID_SUCCESS';
export const GET_OFFER_BY_ID_ERROR = 'GET_OFFER_BY_ID_ERROR';

export const CREATE_OFFER = 'CREATE_OFFER';
export const CREATE_OFFER_SUCCESS = 'CREATE_OFFER_SUCCESS';
export const CREATE_OFFER_ERROR = 'CREATE_OFFER_ERROR';

export const UPDATE_OFFER = 'UPDATE_OFFER';
export const UPDATE_OFFER_SUCCESS = 'UPDATE_OFFER_SUCCESS';
export const UPDATE_OFFER_ERROR = 'UPDATE_OFFER_ERROR';

export const UPLOAD_OFFER_WALLET = 'UPLOAD_OFFER_WALLET';
export const UPLOAD_OFFER_WALLET_SUCCESS = 'UPLOAD_OFFER_WALLET_SUCCESS';
export const UPLOAD_OFFER_WALLET_ERROR = 'UPLOAD_OFFER_WALLET_ERROR';

export const DELETE_OFFER = 'DELETE_OFFER';
export const DELETE_OFFER_SUCCESS = 'DELETE_OFFER_SUCCESS';
export const DELETE_OFFER_ERROR = 'DELETE_OFFER_ERROR';

export const GET_ALL_ORIGINATORS = 'GET_ALL_ORIGINATORS';
export const GET_ALL_ORIGINATORS_SUCCESS = 'GET_ALL_ORIGINATORS_SUCCESS';
export const GET_ALL_ORIGINATORS_ERROR = 'GET_ALL_ORIGINATORS_ERROR';

export const GET_ALL_INDUSTRY = 'GET_ALL_INDUSTRY';
export const GET_ALL_INDUSTRY_SUCCESS = 'GET_ALL_INDUSTRY_SUCCESS';
export const GET_ALL_INDUSTRY_ERROR = 'GET_ALL_INDUSTRY_ERROR';

export const GET_ALL_OPERATION = 'GET_ALL_OPERATION';
export const GET_ALL_OPERATION_SUCCESS = 'GET_ALL_OPERATION_SUCCESS';
export const GET_ALL_OPERATION_ERROR = 'GET_ALL_OPERATION_ERROR';

export const GET_ALL_OFFER_STATUS = 'GET_ALL_OFFER_STATUS';
export const GET_ALL_OFFER_STATUS_SUCCESS = 'GET_ALL_OFFER_STATUS_SUCCESS';
export const GET_ALL_OFFER_STATUS_ERROR = 'GET_ALL_OFFER_STATUS_ERROR';

export const GET_ALL_INDEXER = 'GET_ALL_INDEXER';
export const GET_ALL_INDEXER_SUCCESS = 'GET_ALL_INDEXER_SUCCESS';
export const GET_ALL_INDEXER_ERROR = 'GET_ALL_INDEXER_ERROR';

export const GET_ALL_STRUCTURER = 'GET_ALL_STRUCTURER';
export const GET_ALL_STRUCTURER_SUCCESS = 'GET_ALL_STRUCTURER_SUCCESS';
export const GET_ALL_STRUCTURER_ERROR = 'GET_ALL_STRUCTURER_ERROR';

export const GET_ALL_DOC_TYPE = 'GET_ALL_DOC_TYPE';
export const GET_ALL_DOC_TYPE_SUCCESS = 'GET_ALL_DOC_TYPE_SUCCESS';
export const GET_ALL_DOC_TYPE_ERROR = 'GET_ALL_DOC_TYPE_ERROR';

export const GET_ALL_DOC_SUBTYPE = 'GET_ALL_DOC_SUBTYPE';
export const GET_ALL_DOC_SUBTYPE_SUCCESS = 'GET_ALL_DOC_SUBTYPE_SUCCESS';
export const GET_ALL_DOC_SUBTYPE_ERROR = 'GET_ALL_DOC_SUBTYPE_ERROR';

export const GET_ALL_EMAIL_USERS = 'GET_ALL_EMAIL_USERS';
export const GET_ALL_EMAIL_USERS_SUCCESS = 'GET_ALL_EMAIL_USERS_SUCCESS';
export const GET_ALL_EMAIL_USERS_ERROR = 'GET_ALL_EMAIL_USERS_ERROR';
